import {
  Button,
  DatePicker,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Table,
  Select,
  Checkbox,
  Tooltip,
  message
} from "antd";
import "leaflet-arrowheads";
import dayjs from "dayjs";
import React, { Component } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { CloseOutlined } from "@ant-design/icons";
import "@elfalem/leaflet-curve";
import { Icon } from "leaflet";
import { MapContainer, TileLayer } from "react-leaflet";
import config from "../config";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";

import { addMinutes, format } from "date-fns";
import Draggable from "react-draggable";

import HistoryTrackingStore from "../store/HistoryTrackingStore";
import { observer } from "mobx-react-lite";
import { StoreContext } from "../store/RootStore";
import { CaretRightOutlined, UpOutlined, DownOutlined, SwapRightOutlined, ClockCircleOutlined } from '@ant-design/icons';

import "leaflet-curve"; // Include the Leaflet-Curve library

import CompanyStore from "../store/CompanyStore";
import AdditionalContentInMap from "./AdditionalContentInMap";
import { PauseCircle, PlayCircle } from "react-bootstrap-icons";
import { Spin } from "antd";

import startIconImg from "../assets/images/NewDesign/start.png";
import finishIconImg from "../assets/images/NewDesign/finish.png";
import playIconImg from "../assets/images/NewDesign/play.png";
import pauseIconImg from "../assets/images/NewDesign/pause.png";

import harshBrakingIconImg from "../assets/images/NewDesign/harshBraking.png";
import harshAccelerationIconImg from "../assets/images/NewDesign/harshAcceleration.png";
import harshCorneringIconImg from "../assets/images/NewDesign/harshCornering.png";

import harshBrakingMapIconImg from "../assets/images/NewDesign/harshBrakingmap.png";
import harshAccelerationMapIconImg from "../assets/images/NewDesign/harshAccelerationmap.png";
import harshCorneringMapIconImg from "../assets/images/NewDesign/harshCorneringmap.png";

import runningIconImg from "../assets/images/NewDesign/running.png";
import idleIconImg from "../assets/images/NewDesign/idle.png";
import stopIconImg from "../assets/images/NewDesign/stop.png";
import overspeedIconImg from "../assets/images/NewDesign/overspeed.png";
import navigationIcon from "../assets/images/NewDesign/navigation.png";

import navigationGreenIcon from "../assets/images/NewDesign/navigation-green.png";
import navigationRedIcon from "../assets/images/NewDesign/navigation-red.png";
import navigationYellowIcon from "../assets/images/NewDesign/navigation-yellow.png";

import upArrow from "../assets/images/NewDesign/up-arrow.png";
import downArrow from "../assets/images/NewDesign/down-arrow.png";

import subTripStart from "../assets/images/NewDesign/subtrip-start.png";
import subTripEnd from "../assets/images/NewDesign/subtrip-end.png";




// import "leaflet-curve/dist/leaflet.curve.css"; // Include the CSS
const { RangePicker } = DatePicker;
const { Option } = Select;


class HistoryTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMapOptions: false,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      update: 0,
      update2: 0,
      isPlaying: false,
      currentIndex: 0,
      progress: 0,
      speed: 1,
      showEventModal: false,
      selectedEvents: [],
      vehicleId: 0,
      totalTrips: 0,
      expandedTrips: {},
      expanded: false,
      dataCame: false,
      dataCame2: false,
      loadingTrip: false,
      minimized: false,
      tripData: [],
      showRouteTable: false,
      activeEvents: {
        harshBraking: false,
        harshAcceleration: false,
        harshCornering: false,
        overspeed: false,
        running: false,
        idle: false,
        stop: false,
      },
      selectedTrip: null,

    };

    this.historyTrackingStore = new HistoryTrackingStore(this);
    this.formRef = React.createRef();
    //this.mapRef = React.createRef();
    this.mapRef = this.props?.mapRef ?? React.createRef();
    this.polylines = {};

    // this.speed = 1;
    this.plotPolyLine = [];
    this.activities = [];
    this.totalPoints = 0;
    this.currentProgressIndex = 0;

    //this.isPlaying = false;
    this.currentIndex = 0;
    this.progress = 0;

    this.startTime = null;
    this.elapsedBeforePause = 0;

    this.raf = null;

    this.eventLayers = {
      harshBraking: L.layerGroup(),
      harshAcceleration: L.layerGroup(),
      harshCornering: L.layerGroup(),
      running: L.layerGroup(),
      idle: L.layerGroup(),
      stop: L.layerGroup(),
      overspeed: L.layerGroup(),
    };


  }

  waitForMapAndLoad = () => {
    if (this.mapRef?.current) {
      this.onFinishHistoryTracking();
    } else {
      // Retry until map is mounted
      setTimeout(() => this.waitForMapAndLoad(), 100);
    }
  };
  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });

      this.setState({ loadingTrip: true })
      await this.historyTrackingStore.getVehicles({
        companyId: this.props.getUserData().userCompanyId,
      });

      // console.log(this.props.vehicleInfoObj);
      if (this.props?.fromLivetracking == 1) {


        if (this.props.vehicleInfoObj) {
          const obj = this.props.vehicleInfoObj;
          this.setState({ vehicleId: obj.vehicleId })
          this.formRef.current?.setFieldsValue({
            vehicleId: obj.vehicleId
          });
          //this.onFinishHistoryTracking();
          this.waitForMapAndLoad();
        }
        this.setState({ update: 1 });
      }


      this.setState({ loadingTrip: false })

    }

    this.columns = [
      {
        // title: "Location",
        title: this.context.translate(
          "_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"
        ),
        dataIndex: "formatted_address",
        width: "50%",
      },
      {
        // title: "Speed(Km)",
        title: this.context.translate("_SPEED_KM_"),
        dataIndex: "speed",
        width: "15%",
      },
      {
        // title: "Ignition",
        title: this.context.translate("_IGNITION_"),
        dataIndex: "ignition",
        width: "10%",
        render: (val, record) => {
          if (Number(record.acc) === 1) {
            return <>ON</>;
          } else {
            return <>OFF</>;
          }
        },
      },
      {
        // title: "Date Time",
        title: this.context.translate("_DATE_TIME_"),
        dataIndex: "updatedate",
        render: (value) => {
          const formattedDateTime = dayjs(value).format(
            "DD-MM-YYYY hh:mm:ss A"
          );
          return <>{formattedDateTime}</>;
        },
        width: "25%",
      },
    ];
    this.setState({ update: 1 });

  }

  toggleTrip = (index) => {
    this.setState((prev) => ({
      expandedTrips: {
        ...prev.expandedTrips,
        [index]: !prev.expandedTrips[index],
      },
    }));
  };

  onFinishHistoryTracking = async (data) => {
    await this.setState({ tripData: [], dataCame: false });
    this.clearMap();

    const tripObj = {
      companyId: this.state.companyId,
      vehicleId: this.state.vehicleId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      eventId: this.state.eventId,
      TripEventdata: data?.TripEventdata ? data?.TripEventdata : 0,
      interval: 0,
      offset: 0,
      limit: 10,
      page: 0,
      total: true
    };
    //console.log(data.SelRoutOption)

    const resp = await this.historyTrackingStore.showTripData(tripObj);


    if (resp?.length == 0) {
      // Modal.warning({
      //   content: "Asset Data Not Available...",
      //   title: "Alert",
      // });
      await message.error("Asset Data Not Available...", 2);
    } else {
      const updatedTrip = resp.map(item => ({
        ...item,
        startTime: item.fromDate,
        stopTime: item.toDate
      }));
      // console.log(updatedTrip)
      // this.tripData.push(updatedTrip[0]);
      this.setState((prevState) => ({
        tripData: [...prevState.tripData, updatedTrip[0]],
      }));
      this.setState({ dataCame: true, totalTrips: this.historyTrackingStore.tripCount })

    }



    if (resp?.length > 0) {
      tripObj.total = false;
      tripObj.offset = -1;

      const allTrips = await this.historyTrackingStore.showTripData(tripObj);
      //      console.log(allTrips)
      allTrips?.forEach(item => {
        //this.tripData.push(item);

        this.setState((prevState) => ({
          tripData: [...prevState.tripData, item],
        }));
      });
      //    console.log(this.tripData);

      this.setState({ totalTrips: allTrips?.length })
    }

    await this.setState({ update2: 1, });
  };

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState(
        {
          fromDate: dates[0].format(format),
          toDate: dates[1].format(format),
        },
        () => {
          this.onFinishHistoryTracking(); // ✅ runs after state is updated
        }
      );
    }
  };

  createStaticIcon = (img) => {
    return L.icon({
      iconUrl: img,
      iconSize: [30, 30],
      iconAnchor: [14, 28], // bottom center
    });
  };

  createIcon = (angle = 0, activity = 'Travel') => {

    let iconSrc;
    //  console.log(activity)

    if (activity === 'Stop') {
      iconSrc = navigationRedIcon;
    } else if (activity === 'Idle') {
      iconSrc = navigationYellowIcon; // default (Travel)
    } else {
      iconSrc = navigationGreenIcon;
    }

    return L.divIcon({
      html: `
       <div style="
        transform: rotate(${angle}deg);
        transform-origin: center;
        transition: transform 0.1s linear;
      ">
        <img src="${iconSrc}" style="width: 100%; height: 100%;" />
      </div>
    `,
      className: "",
      iconSize: [20, 20],
      iconAnchor: [10, 10],
    });
  };


  toggleAnimation = () => {
    if (this.currentIndex >= this.plotPolyLine.length - 1) {
      this.currentIndex = 0;
      this.progress = 0;
      this.elapsedBeforePause = 0;
      this.startTime = null;
      this.movingMarker.setLatLng(this.plotPolyLine[0]);
      this.movingMarker.setIcon(this.createIcon(this.plotDirections[0] || 0, this.activities[0] || 0));
    }

    if (this.state.isPlaying) {
      // ⏸ PAUSE
      this.setState({ isPlaying: false });

      if (this.raf) cancelAnimationFrame(this.raf);

      if (this.startTime) {
        this.elapsedBeforePause += performance.now() - this.startTime;
      }

      this.startTime = null;

    } else {
      // ▶ PLAY / RESUME
      this.setState({ isPlaying: true });

      this.startTime = performance.now();

      this.raf = requestAnimationFrame(this.animate);
    }
  };



  animate = (timestamp) => {
    if (!this.state.isPlaying) return;

    if (!this.startTime) {
      this.startTime = timestamp;
    }

    const durationPerSegment = 1000 / this.state.speed;

    const start = this.plotPolyLine[this.currentIndex];
    const end = this.plotPolyLine[this.currentIndex + 1];
    //console.log(this.activities)

    if (!start || !end) {
      this.setState({ isPlaying: false });
      this.movingMarker.setIcon(this.createIcon(this.plotDirections[this.currentIndex] || 0, this.activities[this.currentIndex] || 0));
      return;
    }
    const bearing = this.plotDirections[this.currentIndex] || 0;
    const direction = this.activities[this.currentIndex] || 0;
    // total elapsed including pauses
    const elapsed =
      this.elapsedBeforePause + (timestamp - this.startTime);

    let progress = elapsed / durationPerSegment;

    if (progress > 1) progress = 1;

    const lat =
      Number(start[0]) +
      (Number(end[0]) - Number(start[0])) * progress;

    const lng =
      Number(start[1]) +
      (Number(end[1]) - Number(start[1])) * progress;

    this.movingMarker.setLatLng([lat, lng]);
    this.movingMarker.setIcon(this.createIcon(bearing, direction));

    if (progress < 1) {
      this.raf = requestAnimationFrame(this.animate);
    } else {
      // next segment
      this.currentIndex++;

      this.startTime = performance.now();
      this.elapsedBeforePause = 0;

      if (this.currentIndex < this.plotPolyLine.length - 1) {
        this.raf = requestAnimationFrame(this.animate);
      } else {


        //this.isPlaying = false;
        this.setState({ isPlaying: false })

        // reset state for restart
        this.currentIndex = 0;
        this.progress = 0;
        this.startTime = null;
        this.elapsedBeforePause = 0;

        // move marker back to start
        this.movingMarker.setLatLng(this.plotPolyLine[0]);

        // show PLAY icon
        this.movingMarker.setIcon(this.createIcon(this.plotDirections[0] || 0));

      }
    }
  };
  startPolylineAnimation = () => {
    const latlngs = this.plotPolyLine;

    if (!latlngs || latlngs.length < 2) return;


    this.currentIndex = 0;
    this.progress = 0;
    this.startTime = null;
    //this.isPlaying = false;'
    this.elapsedBeforePause = 0;
    this.setState({ isPlaying: false })

    if (this.raf) cancelAnimationFrame(this.raf);

    this.movingMarker = L.marker(latlngs[0], {
      icon: this.createIcon(this.plotDirections[0] || 0, this.activities[0] || 0),
    })
      .addTo(this.mapRef.current)
      .on("click", this.toggleAnimation);

    //this.raf = requestAnimationFrame(this.animate);
    //f (this.raf) cancelAnimationFrame(this.raf);
  };

  showTripPolyline = async (key, data) => {
    //this.clearMap();
    // Prepare polyline points

    this.plotPolyLine = data.map((val) => [val.latitude, val.longitude]);
    this.plotDirections = data.map((val) => Number(val.direction || 0));
    this.activities = data.map((val) => val.activity);

    console.log('direction:', this.plotDirections[this.currentIndex]);

    if (!this.plotPolyLine || this.plotPolyLine.length < 2) return;
    this.totalPoints = this.plotPolyLine.length;
    this.currentProgressIndex = 0;

    // Remove previous animation if any
    if (this.raf) cancelAnimationFrame(this.raf);
    if (this.movingMarker) {
      this.mapRef.current.removeLayer(this.movingMarker);
    }

    console.log("this.mapRef", this.mapRef);
    console.log("this.props.mapRef", this.props.mapRef);

    // Draw polyline
    const polyline = L.polyline(this.plotPolyLine, {
      color: "#1C8EC2",
      smoothFactor: 5,
      weight: 4,
      id: key,
    }).addTo(this.mapRef.current);

    // 👉 START + END markers
    const startPoint = this.plotPolyLine[0];
    const endPoint = this.plotPolyLine[this.plotPolyLine.length - 1];

    // remove old ones if exist
    if (this.startMarker) {
      this.mapRef.current.removeLayer(this.startMarker);
    }
    if (this.endMarker) {
      this.mapRef.current.removeLayer(this.endMarker);
    }

    // create markers
    this.startMarker = L.marker(startPoint, {
      icon: this.createStaticIcon(startIconImg),
    }).addTo(this.mapRef.current);

    this.endMarker = L.marker(endPoint, {
      icon: this.createStaticIcon(finishIconImg),
    }).addTo(this.mapRef.current);

    this.polylines[key] = polyline;

    // Fit bounds
    const bounds = polyline.getBounds();
    this.mapRef.current.fitBounds(bounds, { minZoom: 10 });

    // 👉 Create marker at start (PLAY icon)
    this.currentIndex = 0;
    this.progress = 0;
    this.startTime = null;
    this.elapsedBeforePause = 0;
    //this.isPlaying = false;
    this.setState({ isPlaying: false })

    const initialBearing = this.plotDirections[0] || 0;

    this.movingMarker = L.marker(this.plotPolyLine[1], {
      icon: this.createIcon("play"),
    })
      .addTo(this.mapRef.current)
      .on("click", this.toggleAnimation);

    // 🔥 CLICK ON POLYLINE → START FROM THAT POINT
    polyline.on("click", (e) => {
      const latlng = e.latlng;

      let nearestIndex = 0;
      let minDist = Infinity;

      this.plotPolyLine.forEach((point, i) => {
        const dist = this.mapRef.current.distance(latlng, L.latLng(point));
        if (dist < minDist) {
          minDist = dist;
          nearestIndex = i;
        }
      });

      // reset state properly
      this.currentIndex = nearestIndex;
      this.elapsedBeforePause = 0;
      this.startTime = performance.now();

      this.movingMarker.setLatLng(this.plotPolyLine[nearestIndex]);

      ///this.isPlaying = true;
      this.setState({ isPlaying: true })
      this.movingMarker.setIcon(this.createIcon("pause"));

      if (this.raf) cancelAnimationFrame(this.raf);

      this.raf = requestAnimationFrame(this.animate);


    });
    this.addEventMarkers(data);
  };


  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    if (this.movingMarker) {
      this.mapRef.current.removeLayer(this.movingMarker);
    }
  }

  handleCheckboxChange = async (record) => {
    //console.log(record);
    // this.tripData = [];


    this.setState({ selectedTrip: record, loadingTrip: true });
    this.clearMap();

    const tripDataObj = {
      companyId: this.state.companyId,
      vehicleId: record.vehicleId,
      fromDate: record.startTime,
      toDate: record.stopTime,
      SelRoutOption: 4,
      TripEventdata: 1,
    };

    try {
      const data = await this.historyTrackingStore.getHistTracDataForTrip(
        tripDataObj
      );
      await this.showTripPolyline(record.startTime, data);
    } finally {
      this.setState({ loadingTrip: false, dataCame2: true });
    }


    if (this.raf) cancelAnimationFrame(this.raf);

    //console.log(data);

    // await this.showTripPolyline(key, data);



  };

  changeSpeed = (newSpeed) => {
    if (newSpeed <= 0) return;

    // update UI
    this.setState({ speed: newSpeed });

    // update internal speed for animation
    if (this.state.isPlaying && this.startTime) {
      const now = performance.now();

      this.elapsedBeforePause += now - this.startTime;
      this.startTime = now;
    }

    this.speed = newSpeed;
  };

  getAngle = (start, end) => {
    const dy = end[0] - start[0];
    const dx = end[1] - start[1];
    return Math.atan2(dy, dx) * (180 / Math.PI);
  };

  convertToFormattedTime = (time) => {
    if (time) {
      const [hours, minutes] = time?.split(":");

      const formattedTime = `${hours}: ${minutes}:00`;
      return formattedTime;
    }
  };

  clearMap = async () => {
    //console.log('clearmap called');
    await this.mapRef?.current?.eachLayer((layer) => {
      //console.log(layer);
      if (layer instanceof L.Polyline) {

        this.mapRef?.current?.removeLayer(layer);
      }
    });

    await this.mapRef?.current?.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        this.mapRef?.current?.removeLayer(layer);
      }
    });

    Object.keys(this.eventLayers).forEach((key) => {
      const layer = this.eventLayers[key];
      this.mapRef.current.removeLayer(layer);
      this.setState((prevState) => ({
        activeEvents: {
          ...prevState.activeEvents,
          [key]: false,
        },
      }));

    });

    //this.setState({dataCame:false,dataCame2:false})
    // this.tripData =[]
  }

  // handleEventChange = (checkedValues) => {
  //   this.setState({ selectedEvents: checkedValues });


  //   // toggle layers
  //   Object.keys(this.eventLayers).forEach((key) => {
  //     const layer = this.eventLayers[key];

  //     if (checkedValues.includes(key)) {
  //       layer.addTo(this.mapRef.current);
  //     } else {
  //       this.mapRef.current.removeLayer(layer);
  //     }
  //   });
  // };

  handleEventChange = (key) => {
    //console.log('NNNNNNNNNNNNNNNNNNNNNNNNN')
    const isActive = this.state.activeEvents[key] !== false;

    // toggle Leaflet layer visibility
    if (this.eventLayers[key]) {
      if (isActive) {
        this.mapRef.current.removeLayer(this.eventLayers[key]);
      } else {
        this.mapRef.current.addLayer(this.eventLayers[key]);
      }
    }

    this.setState((prev) => ({
      activeEvents: {
        ...prev.activeEvents,
        [key]: !isActive,
      },
    }));
  };

  addEventMarkers = (data) => {
    //console.log(data);

    console.log(this.eventLayers)
    Object.keys(this.eventLayers).forEach((key) => {
      this.eventLayers[key].clearLayers();
    });

    const overspeedPoints = [];

    data.forEach((point) => {
      const latlng = [point.latitude, point.longitude];

      // 🔹 1. Activity → color + layer
      let layerKey = null;
      let color = null;

      if (point.activity === "Travel") {
        color = "#22c55e";
        layerKey = "running";
      } else if (point.activity === "Idle") {
        color = "#eab308";
        layerKey = "idle";
      } else if (point.activity === "Stop") {
        color = "#ef4444";
        layerKey = "stop";
      }


      if (!color) return;
      let icon

      // point.extAlarm = 1;
      //point.extAlarm = 2;
      // point.extAlarm = 3;

      if (point.extAlarm == 1) layerKey = "harshBraking";
      else if (point.extAlarm == 2) layerKey = "harshAcceleration";
      else if (point.extAlarm == 3) layerKey = "harshCornering";
      if (point.extAlarm == 1 || point.extAlarm == 2 || point.extAlarm == 3) {
        const alarmIconMap = {
          1: harshBrakingMapIconImg,
          2: harshAccelerationMapIconImg,
          3: harshCorneringMapIconImg,
        };

        icon = L.icon({
          iconUrl: alarmIconMap[point.extAlarm],
          iconSize: [20, 20],
          iconAnchor: [10, 10],
        });

      } else {

        // 🔹 2. Rotation snapped to nearest 45°
        const rotationAngle = Number(point.direction || 0);
        const rotation = Math.round(rotationAngle / 45) * 45;

        // 🔹 3. Arrow SVG icon
        const arrowSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
          style="transform: rotate(${rotation}deg); display:block;">
          <polygon
            points="12,2 20,20 12,15 4,20"
            fill="${color}"
            stroke="#fff"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
        </svg>
      `;

        icon = L.divIcon({
          html: arrowSvg,
          className: "",
          iconSize: [24, 24],
          iconAnchor: [12, 12],
        });
      }

      // 🔹 4. Marker + tooltip
      const marker = L.marker(latlng, { icon });
      //    Direction: ${rotationAngle}°<br/>
      marker.bindTooltip(`
        <b>${point.activity}</b><br/>
    
        Speed: ${point.speed ?? 0} km/h
      `);

      // console.log(this.eventLayers)

      // 🔹 5. Add to layer
      //this.eventLayers[layerKey].removeLayer();
      this.eventLayers[layerKey].addLayer(marker);
      //point.speedLimit = 50;

      // console.log('innnnnBBBBBB');

      if (point.speed > point.speedLimit) {
        //console.log('111111')
        overspeedPoints.push(latlng);
      } else {
        //console.log('22222222')
        // speed dropped — draw collected segment and reset
        if (overspeedPoints.length > 1) {
          //console.log("sSSSSS");
          this.drawOverspeedPolyline(overspeedPoints);
        }
        overspeedPoints.length = 0;


      }



    });
  };

  drawOverspeedPolyline = (points) => {
    const polyline = L.polyline(points, {
      color: "#ef4444",
      weight: 4,
      opacity: 0.9,
      dashArray: "8, 4",   // dashed so it's distinct from the main route line
    });

    polyline.bindTooltip(`
        
        Vehicle Speed Limit: ${points.speedLimit}<br/>
        Speed : ${points.speed ?? 0} km/h
      `);

    // add to overspeed layer if you have one, otherwise directly to map
    if (this.eventLayers["overspeed"]) {
      this.eventLayers["overspeed"].addLayer(polyline);
    } else {
      polyline.addTo(this.mapRef.current);
    }
  };

  handleMinimize = () => {
    this.setState((prev) => ({ minimized: !prev.minimized }));
  };

  // addEventMarkers = (data) => {
  //   data.forEach((point) => {
  //   // console.log(point.activity);

  //     const latlng = [point.latitude, point.longitude];

  //     // 🔹 1. Decide event layer
  //     let layerKey = null;

  //     // switch (point.eventType) {
  //     //   case "harshBraking":
  //     //     layerKey = "harshBraking";
  //     //     break;
  //     //   case "harshAcceleration":
  //     //     layerKey = "harshAcceleration";
  //     //     break;
  //     //   case "harshCornering":
  //     //     layerKey = "harshCornering";
  //     //     break;
  //     //   case "running":
  //     //     layerKey = "running";
  //     //     break;
  //     //   case "idle":
  //     //     layerKey = "idle";
  //     //     break;

  //     //   case "stop":
  //     //     layerKey = "stop";
  //     //     break;
  //     //   default:
  //     //     return;
  //     // }

  //     // 🔹 2. Activity color
  //     let activity = null;
  //     console.log(point.activity);

  //     if (point.activity === "Travel") {
  //       activity = "Green";
  //       layerKey = "running";
  //     } else if (point.activity === "Idle") {
  //       activity = "Orange";
  //       layerKey = "idle";
  //     } else if (point.activity === "Stop") {
  //       activity = "Red";
  //       layerKey = "stop";
  //     }
  //     console.log(activity);

  //     if (!activity) return;

  //     console.log(activity)

  //     // 🔹 3. Direction calculation
  //     let rotationAngle = Number(point.direction || 0);
  //     let direction = "";

  //     if (rotationAngle >= 0 && rotationAngle < 22.5) direction = "north";
  //     else if (rotationAngle < 67.5) direction = "north-east";
  //     else if (rotationAngle < 112.5) direction = "east";
  //     else if (rotationAngle < 157.5) direction = "south-east";
  //     else if (rotationAngle < 202.5) direction = "south";
  //     else if (rotationAngle < 247.5) direction = "south-west";
  //     else if (rotationAngle < 292.5) direction = "west";
  //     else if (rotationAngle < 337.5) direction = "north-west";
  //     else direction = "north";

  //     // 🔹 4. Icon path
  //     const iconUrl = require(`../assets/images/BaloonIcons/${activity}-${direction}.png`);

  //     const icon = L.icon({
  //       iconUrl,
  //       iconSize: [30, 30],
  //       iconAnchor: [15, 30],
  //     });

  //     const marker = L.marker(latlng, { icon });

  //     // 🔹 5. Add to layer
  //     this.eventLayers[layerKey].addLayer(marker);
  //   });
  // };

  render() {
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };
    const { minimized, visible } = this.state;

    return (
      <div>

        <div

          dir={this.context.locale.language === "arabic" ? "ltr" : "ltr"}
          className={
            this.context.locale.language === "arabic"
              ? "arabic-map-container"
              : ""
          }
        >
          <MapContainer
            ref={this.mapRef}
            zoom={config.mapZoom}
            // minZoom={5}
            center={config.mapCenter}
            style={{ position: "sticky", height: "90vh", width: "100wh" }}
          >
            {this.state.mapType === "openstreet" ? (
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            ) : (
              <ReactLeafletGoogleLayer />
            )}

            <AdditionalContentInMap
              This={this}
              size="small"
              showMapOptions={this.state.showMapOptions}
              mapType={this.state.mapType}
            />
          </MapContainer>
        </div>
        <div style={{ position: "fixed", top: 80, left: 0, zIndex: 1000 }}>
          <Draggable
            handle=".handle"
            defaultPosition={
              this.props.trackingMapBoolean
                ? { x: 340, y: 20 }
                : { x: 850, y: 20 }
            }
          >
            <div style={{ width: 1500 }}>
              <Card
                className="live-routepath-modal"
                styles={{
                  header: { background: "#1a2b5e", padding: "12px 16px", borderRadius: "12px 12px 0 0" },
                  body: { padding: "14px 16px" },
                }}
                title={
                  <div
                    className="handle"
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    <span style={{ fontSize: "15px", fontWeight: 500 }}>
                      {this.context.translate("_HISTORY_TRACKING_")}
                    </span>
                    <Button
                      size="small"
                      type="text"
                      style={{ color: "#8b1111" }}
                      onClick={this.handleMinimize}
                    >
                      <img
                        src={minimized ? upArrow : downArrow}
                        alt="toggle"
                        style={{ width: 10, height: 10 }}
                      />
                    </Button>
                  </div>
                }
                bodyStyle={{ display: minimized ? "none" : "block" }}
              >
                {this.state.loadingTrip && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(255,255,255,0.8)",
                      zIndex: 10000
                    }}
                  >
                    <Spin size="medium" />
                  </div>
                )}

                <Form onFinish={this.onFinishHistoryTracking} layout="vertical" ref={this.formRef}>

                  {/* Account + Vehicle in 2 columns */}
                  <Row gutter={10}>
                    {(this.props.getUserData().isadmin === -1 || this.props.getUserData().isadmin === 3) && (
                      <Col span={12}>
                        <Form.Item
                          name="companyId"
                          label={<span style={{ fontSize: 12 }}>{this.context.translate("_FLEET_DASHBORD_NEWPOI_CUSTOMER_")}<span style={{ color: "red" }}> *</span></span>}
                          rules={[{ required: true }]}
                        >
                          <CompanyAutocomplete
                            className="history-picker"
                            onChange={async (value) => {
                              await this.setState({ companyId: value.value });
                              await this.historyTrackingStore.getVehicles({ companyId: this.state.companyId });
                              this.setState({ update: 1 });
                            }}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    <Col span={(this.props.getUserData().isadmin === -1 || this.props.getUserData().isadmin === 3) ? 12 : 24}>
                      <Form.Item
                        label={<span style={{ fontSize: 12 }}>{this.context.translate("_VEHICLES_")}<span style={{ color: "red" }}> *</span></span>}
                        name="vehicleId"
                        rules={[{ required: true }]}
                      >
                        <Select
                          onSelect={(val) => {
                            this.setState({ vehicleId: val });
                            this.onFinishHistoryTracking();
                          }}
                          value={this.state.vehicleId}
                          showSearch
                          filterOption={(inputValue, option) =>
                            option.children?.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                          }
                          className="history-picker"
                        >
                          {this.historyTrackingStore?.vehiclesArray?.map((val) => (
                            <Option value={val.vehicleId} key={val.vehicleId}>
                              {val.vehicleNo}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Date Range */}
                  <Form.Item
                    label={<span style={{ fontSize: 12 }}>{this.context.translate("_SELECT_DATE_")}</span>}
                    name="dateRange"
                    className="history-picker"
                  >
                    <RangePicker
                      placeholder={[
                        this.context.translate("_FROM_DATE_TIME_"),
                        this.context.translate("_TO_DATETIME_"),
                      ]}
                      format="DD-MM-YYYY hh:mmA"
                      style={{ width: "100%" }}
                      onChange={(val) => this.onDateTimeChange(val)}
                      disabledDate={(current) => current && current > dayjs()}
                      showTime={{
                        format: "h:mmA",
                        defaultValue: [dayjs().startOf("day"), dayjs()],
                      }}
                      defaultValue={[dayjs().startOf("day"), dayjs()]}
                    />
                  </Form.Item>

                  {/* Track Vehicle slider */}
                  <Form.Item
                  // label={<span style={{ fontSize: 12 }}>Track Vehicle</span>}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>



                      <img
                        src={this.state.isPlaying ? pauseIconImg : playIconImg}
                        alt="play"
                        onClick={
                          this.state.dataCame2 ? this.toggleAnimation : undefined
                        }
                        style={{
                          width: 20,
                          height: 20,
                          cursor: this.state.dataCame2 ? "pointer" : "not-allowed",
                          opacity: this.state.dataCame2 ? 1 : 0.4,
                          pointerEvents: this.state.dataCame2 ? "auto" : "none"
                        }}
                      />

                      <input
                        type="range"
                        min="0.5"
                        max="5"
                        step="0.5"
                        value={this.state.speed}
                        onChange={(e) => this.changeSpeed(parseFloat(e.target.value))}
                        style={{ flex: 1 }}
                        disabled={!this.state.dataCame2}
                      />
                    </div>
                  </Form.Item>

                  {this.state.dataCame && <span
                    style={{
                      color: "red",
                      fontSize: "11px",
                      display: "block",
                      textAlign: "center",
                      marginBottom: 6
                    }}
                  >{this.context.translate("_HISTORY_TRACKING_MESSAGE_")}</span>}

                  <div style={{ border: "1px solid #e8e8e8", borderRadius: 8, maxHeight: 220, overflowY: "auto", marginBottom: 12 }}>
                    {(() => {
                      const summary = this.state.tripData?.[0];
                      const subTrips = this.state.tripData?.slice(1);

                      const locBlock = (startTime, startAddr, stopTime, stopAddr) => (
                        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>

                          {/* Start */}
                          <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                flexShrink: 0,
                              }}
                            >
                              <img
                                src={subTripStart}
                                alt="start"
                                style={{ width: 14, height: 14, marginTop: 3 }}
                              />
                              <div style={{ width: 1.5, height: "100%", minHeight: 16, background: "#ddd" }} />
                            </div>

                            <div style={{ paddingBottom: 8 }}>
                              <div style={{ fontSize: 13, fontWeight: 600, color: "#222", marginBottom: 2 }}>
                                {startTime}
                              </div>
                              <div style={{ fontSize: 11, color: "#888", lineHeight: 1.4 }}>
                                {startAddr}
                              </div>
                            </div>
                          </div>

                          {/* Stop */}
                          <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                            <div style={{ flexShrink: 0 }}>
                              <img
                                src={subTripEnd}
                                alt="end"
                                style={{ width: 14, height: 14, marginTop: 3 }}
                              />
                            </div>

                            <div>
                              <div style={{ fontSize: 13, fontWeight: 600, color: "#222", marginBottom: 2 }}>
                                {stopTime}
                              </div>
                              <div style={{ fontSize: 11, color: "#888", lineHeight: 1.4 }}>
                                {stopAddr}
                              </div>
                            </div>
                          </div>

                        </div>
                      );

                      return (
                        this.state.dataCame && <div style={{ border: "0.5px solid #e0e0e0", borderRadius: 10, overflow: "hidden", marginBottom: 12 }}>

                          {/* Header — dist, elapsed time, details */}
                          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", borderBottom: "0.5px solid #eee" }}>
                            <span style={{ fontSize: 12, color: "#444", display: "flex", alignItems: "center", gap: 4 }}>
                              <SwapRightOutlined />
                              {summary?.distanceTravelled} km
                            </span>
                            <div style={{ width: 1, height: 14, background: "#ddd" }} />
                            <span style={{ fontSize: 12, color: "#444", display: "flex", alignItems: "center", gap: 4 }}>
                              <ClockCircleOutlined />
                              {summary?.elapsedTime}
                            </span>
                            {this.state.dataCame2 && (<Button size="small"
                              onClick={() => this.setState({ showRouteTable: true })}
                              style={{ marginLeft: "auto", fontSize: 12 }}>
                              {this.context.translate("_DETAILS_")}
                            </Button>)}
                          </div>

                          {/* Summary trip */}
                          <div
                            onClick={() => this.handleCheckboxChange(summary)}
                            style={{ padding: "10px 14px", borderBottom: "0.5px solid #eee", cursor: "pointer" }}>
                            {locBlock(summary?.startTime, summary?.startAddress, summary?.stopTime, summary?.stopAddress)}
                          </div>

                          {/* Expand toggle */}
                          <div
                            onClick={() => this.setState({ expanded: !this.state.expanded })}
                            style={{
                              display: "flex", justifyContent: "space-between", alignItems: "center",
                              padding: "8px 14px", background: "#fafafa",
                              borderBottom: this.state.expanded ? "0.5px solid #eee" : "none",
                              cursor: "pointer"
                            }}
                          >
                            <span style={{ fontSize: 12, fontWeight: 500, color: "#444" }}>
                              {this.context.translate("_TOTAL_")} {this.state.totalTrips} {this.context.translate("_SHIFT_TRIP_COUNT_")}


                            </span>
                            <span style={{ fontSize: 12, color: "#1a73e8", display: "flex", alignItems: "center", gap: 4 }}>
                              {this.state.expanded ? this.context.translate("_COLLAPSE_") : this.context.translate("_EXPAND_")}
                              {this.state.expanded
                                ? <UpOutlined style={{ fontSize: 11 }} />
                                : <DownOutlined style={{ fontSize: 11 }} />
                              }
                            </span>
                          </div>

                          {/* Sub-trips */}
                          {this.state.expanded && subTrips?.map((trip, index) => {
                            const isSelected =
                              this.state.selectedTrip?.startTime === trip?.startTime &&
                              this.state.selectedTrip?.stopTime === trip?.stopTime;
                            return (
                              <div key={index} onClick={() => this.handleCheckboxChange(trip)}
                                style={{
                                  padding: "10px 14px", borderBottom: "0.5px solid #f0f0f0", cursor: "pointer",
                                  background: isSelected
                                    ? "#e6f4ff"
                                    : index % 2 === 0 ? "#fff" : "#f7f8fa",
                                }}>
                                <div style={{ display: "flex", gap: 12, marginBottom: 8 }}>
                                  <span style={{ fontSize: 11, color: "#666" }}><SwapRightOutlined /> {trip?.distanceTravelled} km</span>
                                  <span style={{ fontSize: 11, color: "#666" }}><ClockCircleOutlined /> {trip?.elapsedTime}</span>
                                </div>
                                {locBlock(trip?.startTime, trip?.startLocation, trip?.stopTime, trip?.stopLocation)}
                              </div>
                            )
                          })}

                        </div>
                      );
                    })()}
                  </div>

                  {/* Footer buttons */}
                  <div style={{ display: "flex", gap: 10, paddingTop: 12, borderTop: "1px solid #eee" }}>
                    <Button
                      style={{ flex: 1 }}
                      onClick={() => this.clearMap()}
                    >
                      {this.context.translate("_FLEET_CLEAR_BTN_")}
                    </Button>
                    <Button
                      type="primary"
                      disabled={!this.state.dataCame2}
                      style={{
                        flex: 1,
                        background: this.state.dataCame2 ? "#1a2b5e" : undefined,
                        borderColor: this.state.dataCame2 ? "#1a2b5e" : undefined,
                        opacity: this.state.dataCame2 ? 1 : 0.5,
                      }}
                      onClick={() => this.setState({ showEventModal: true })}
                    >

                      {this.context.translate("_SHOW_EVENTS_")
                      }   </Button>
                  </div>

                </Form>
              </Card>
            </div>
          </Draggable>
          {this.state.showEventModal && (<Draggable handle=".event-handle" defaultPosition={{ x: 400, y: 100 }}>
            <div style={{ position: "absolute", zIndex: 1001, width: 520 }}>
              <Card
                bodyStyle={{ padding: "12px 16px" }}
                className="floatingevents"
                title={
                  <div
                    className="event-handle"
                  >
                    {/* <span style={{ fontSize: 15, fontWeight: 500 }}>Select Events</span> */}
                    <Button
                      type="text"
                      size="small"
                      icon={<CloseOutlined />}
                      onClick={() => this.setState({ showEventModal: false })}
                      style={{ marginLeft: "auto" }}
                    />
                  </div>
                }
              >
                <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 16px" }}>
                  {[
                    { key: "harshBraking", label: this.context.translate("_FLEET_RULESELECTORDETAIL_RULE1_TITLE_") },
                    { key: "harshAcceleration", label: this.context.translate("_HARSH_ACCELERATION_") },

                    { key: "harshCornering", label: this.context.translate("_HARSH_TURNING_") },
                    { key: "overspeed", label: this.context.translate("_OVERSPEED_") },
                    { key: "running", label: this.context.translate("_RUNNING_") },

                    { key: "idle", label: this.context.translate("_IDLE_") },
                    { key: "stop", label: this.context.translate("_STOP_") },
                  ].map(({ key, label }) => {
                    const isActive = this.state.activeEvents[key] !== false; // default all on
                    const eventIcons = {
                      harshBraking: harshBrakingIconImg,
                      harshAcceleration: harshAccelerationIconImg,
                      harshCornering: harshCorneringIconImg,
                      overspeed: overspeedIconImg,
                      running: runningIconImg,
                      idle: idleIconImg,
                      stop: stopIconImg,
                    };  

                    return (


                      <div
                        key={key}
                        onClick={() => this.handleEventChange(key)}
                        style={{
                          display: "flex", flexDirection: "column", alignItems: "center",
                          gap: 6, cursor: "pointer", width: 40,
                          transition: "opacity 0.2s",
                        }}
                      >
                        <div style={{
                          width: 35, height: 35, borderRadius: 10,
                          border: `2px solid ${isActive ? "#1a2b5e" : "#ddd"}`,
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: 24,
                          background: isActive ? "#FFF" : "#1a2b5e",  // white when active
                          transition: "all 0.2s",
                        }}>
                          {/* if using image assets — invert filter makes icon white on dark bg */}
                          <img
                            src={eventIcons[key]}
                            style={{
                              width: 20, height: 20,
                              filter: isActive ? "none" : "brightness(0) invert(1)",  // white icon on blue
                              transition: "filter 0.2s",
                            }}
                          />
                        </div>
                        <span style={{
                          fontSize: 9, textAlign: "center", lineHeight: 1.3,
                          color: isActive ? "#FFF" : "#fff",  // label color also changes
                          fontWeight: isActive ? 500 : 400,
                        }}>
                          {label}
                        </span>
                      </div>
                    )
                  })}
                </div>
              </Card>
            </div>
          </Draggable>
          )}
          {this.state.showRouteTable && (
            <Draggable handle=".table-handle" defaultPosition={{ x: 95, y: 410 }}>
              <div
                style={{
                  position: "absolute",
                  zIndex: 1001,
                  width: "40vw",
                  maxWidth: "900px",
                  maxHeight: "50vh",
                  background: "#fff",
                  borderRadius: 8,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Header */}
                <div
                  className="table-handle"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 16px",
                    background: "#1a2b5e",
                    cursor: "move",
                  }}
                >
                  <span style={{ color: "#fff", fontSize: 12, fontWeight: 500 }}>
                    Route Details
                  </span>
                  <Button
                    type="text"
                    size="small"
                    icon={<CloseOutlined />}
                    style={{ color: "#fff" }}
                    onClick={() => this.setState({ showRouteTable: false })}
                  />
                </div>

                {/* Table */}
                <div style={{ flex: 1 }}>
                  <Table
                    pagination={false}
                    bordered
                    columns={this.columns}
                    dataSource={this.historyTrackingStore.vehicleTrackingData}
                    size="small"
                    scroll={{ y: "calc(50vh - 50px)" }}
                  />
                </div>
              </div>
            </Draggable>
          )}

        </div>
        {/* {this.state.showRouteTable && (<Table
                      pagination={false}
                      className="historyTrackingTable"
                      scroll={{ y: 100 }}
                     
                      bordered
                      columns={
                         this.columns
                      }
                      dataSource={
                        this.historyTrackingStore.vehicleTrackingData
                      }
                   
                    />)} */}

        {/* Show Events Draggable Panel */}



        {/*                  
        <Modal
          title="Select Events"
          open={this.state.showEventModal}
          onCancel={() => this.setState({ showEventModal: false })}
          footer={null}
          style={{ top: 20, left: 10 }}
        >
          <Checkbox.Group
            options={[
              { label: "Harsh Braking", value: "harshBraking" },
              { label: "Harsh Acceleration", value: "harshAcceleration" },
              { label: "Harsh Cornering", value: "harshCornering" },
              { label: "Overspeed", value: "overspeed" },
              { label: "Running", value: "running" },
              { label: "Idle", value: "idle" },
              { label: "Stop", value: "stop" },
            ]}
            value={this.state.selectedEvents}
            onChange={this.handleEventChange}
          />
        </Modal> */}
      </div>


    );

  }

}
HistoryTracking.contextType = StoreContext;
export default observer(withRouter(HistoryTracking));
